import { combineReducers } from 'redux';
import absenceCalendar from './modules/absenceCalendar';
import absenceSets from './modules/absenceSets';
import absenceRequests from './modules/absenceRequests';
import accessControl from './modules/accessControl';
import auth from './modules/auth';
import cycles from './modules/cycles';
import cycleDetails from './modules/cycleDetails';
import dashboard from './modules/dashboard';
import loading from './modules/loading';
import people from './modules/people';
import person from './modules/person';
import attribute from './modules/attribute';
import dialogs from './modules/dialogs';
import attributes from './modules/attributes';
import surveys from './modules/surveys';
import survey from './modules/survey';
import surveySummaries from './modules/surveySummaries';
import surveySummary from './modules/surveySummary';
import fillSurvey from './modules/fillSurvey';
import surveysHistory from './modules/surveysHistory';
import tags from './modules/tags';
import actionPlans from './modules/actionPlans';
import timeline from './modules/timeline';
import employeesHierarchy from './modules/employeesHierarchy';
import competenceMap from './modules/competenceMap';
import personReports from './modules/personReports';
import courses from './modules/courses';
import courseDetails from './modules/courseDetails';
import notes from './modules/notes';
import userCourses from './modules/userCourses';
import privateNotes from './modules/privateNotes';
import actionPlanDetails from './modules/actionPlanDetails';
import oneOnOne from './modules/oneOnOne';
import oneOnOneReport from './modules/oneOnOneReport';
import personAbsences from './modules/personAbsences';
import personRoles from './modules/personRoles';
import personOneOnOne from './modules/personOneOnOne';
import pendingSurveys from './modules/pendingSurveys';
import oneOnOneTopics from './modules/oneOnOneTopics';
import organizationSettings from './modules/organizationSettings';
import documentCategories from './modules/documentCategories';
import companyOverview from './modules/companyOverview';
import jobTitles from './modules/jobTitles';
import jobs from './modules/jobs';
import levelsAndTracks from './modules/levelsAndTracks';
import personCareer from './modules/personCareer';
import signUp from './modules/signUp';
import instructionGuide from './modules/instructionGuide';
import notifications from './modules/notifications';
import divisionsAndDepartments from './modules/divisionsAndDepartments';
import jobDetails from './modules/jobDetails';
import candidateDetails from './modules/candidateDetails';
import roles from './modules/roles';
import permissions from './modules/permissions';
import successionKeyJob from './modules/successionKeyJob';
import successionKeyJobs from './modules/successionKeyJobs';
import successionPool from './modules/successionPool';
import successionPools from './modules/successionPools';
import successionSettings from './modules/successionSettings';

const createRootReducer = () =>
  combineReducers({
    absenceCalendar,
    absenceRequests,
    absenceSets,
    accessControl,
    actionPlans,
    actionPlanDetails,
    attribute,
    attributes,
    auth,
    courses,
    courseDetails,
    companyOverview,
    competenceMap,
    candidateDetails,
    cycles,
    cycleDetails,
    dialogs,
    divisionsAndDepartments,
    dashboard,
    documentCategories,
    employeesHierarchy,
    fillSurvey,
    instructionGuide,
    loading,
    people,
    person,
    personAbsences,
    personRoles,
    personReports,
    personOneOnOne,
    personCareer,
    permissions,
    roles,
    surveys,
    survey,
    surveysHistory,
    surveySummaries,
    surveySummary,
    tags,
    timeline,
    notes,
    userCourses,
    signUp,
    successionKeyJob,
    successionKeyJobs,
    successionPool,
    successionPools,
    successionSettings,
    privateNotes,
    oneOnOne,
    oneOnOneReport,
    oneOnOneTopics,
    pendingSurveys,
    notifications,
    organizationSettings,
    jobTitles,
    jobDetails,
    jobs,
    levelsAndTracks,
  });

export default createRootReducer;
